import { getStatusColor } from '@/_utils/oskar/get-status-color';
import { components } from '@/common/bag-api';
import { Status, statusNameMappings } from '@/common/enums/Status';
import { Result } from '@/reservation/reservation.model';
import { BagReservationListData } from './bag-reservation-list.model';
import { DatePipe } from '@angular/common';
import { CamelCaseKeys } from '@/common/types/snake-to-camel-case';

type ReservationList = CamelCaseKeys<components['schemas']['ReservationList']>;

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export class ProcessReservationData {
	constructor(private readonly datePipe: DatePipe) {}

	processReservationListData = (data: Result<ReservationList>): BagReservationListData[] => {
		return data.results
			.filter((obj) => !!obj)
			.map((obj) => ({
				...obj,
				statusName: {
					name: obj.statusName,
					statusColor: getStatusColor(this.findStatus(obj.statusName)),
				},
				reservationTime: this.parseDateToTable(obj.reservationTime),
				confirmationTime: this.parseDateToTable(obj.confirmationTime),
				expirationTime: this.parseDateToTable(obj.expirationTime),
				canceledAt: this.parseDateToTable(obj.canceledAt),
				totalPrice: this.parsePriceToTable(parseInt(obj.totalPrice)),
				paidAmount: this.parsePriceToTable(obj.paidAmount),
				left2pay: this.parsePriceToTable(parseInt(obj.balance)),
				commissionValue: this.parsePriceToTable(obj.commissionValue),
				promotionValue: this.parsePriceToTable(parseInt(obj.promotionValue) * -1),
				departureTime: this.parseDateToTable(obj.departureTime),
				returnTime: this.parseDateToTable(obj.returnTime),
				id: {
					label: obj.id,
					isLink: true,
					route: `reservation/${obj.id}`,
				},
			})) as unknown as BagReservationListData[];
	};

	private parsePriceToTable(price: number): string {
		return (price * 0.01).toFixed(2).replace('.', ',');
	}

	private parseDateToTable(date: string): string {
		if (!date) {
			return '';
		}
		return this.datePipe.transform(new Date(date), 'dd.MM.yyyy HH:mm:ss') as string;
	}

	private findStatus(statusName: string): Status {
		const normalizedStatusName = statusName.replace(/ /g, '').toLocaleLowerCase();
		const key = Object.keys(statusNameMappings).find(
			(s) => s.replace(/ /g, '').toLocaleLowerCase() === normalizedStatusName,
		);

		if (key) {
			return statusNameMappings[key];
		}

		return null;
	}
}
